export default "__VITE_ASSET__0a3c7b16__"